// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__UA5CJ","button":"Pagination_button__gOLVY","icon":"Pagination_icon__z6vbL"};
module.exports.__checksum = "ee9ae74022e7"
